import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';

@Component({
  selector: 'app-preview-visiting-seva',
  templateUrl: './preview-visiting-seva.component.html',
  styleUrls: ['./preview-visiting-seva.component.scss']
})
export class PreviewVisitingSevaComponent {

  constructor(private toastr: ToastrService, private api: SevaProfileService) { }

  applicantData: any
  sevaPrn: any = {}

  ngOnInit(): void {
    this.sevaPrn = history?.state?.rowData?.ApplicationGuid;
    this.getApplicantData();
  }




  getApplicantData() {
    this.api.apiCall(`Applicant/application/preview?ApplicationGuid=${this.sevaPrn}`, 'GET').subscribe((response: any) => {
      if (response.Data && Object.keys(response.Data).length > 0) {
        this.applicantData = response.Data
      }
    })
  }


}
